import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex items-center mb-2" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 4 }


export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  props: {
    items: {},
    className: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.className)
  }, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: `breadcrumb${index}`,
          class: _normalizeClass([
          'relative mr-6 font-roboto-condensed text-xs',
          `before:content-['>'] before:absolute before:top-1/2 before:-right-4 before:transfrom before:-translate-y-1/2 before:text-zbr-gray-700`,
          index === _ctx.items.length - 1 ? 'text-zbr-black-900 before:hidden' : 'text-zbr-gray-700'
        ])
        }, [
          (item.slot && item.link)
            ? _renderSlot(_ctx.$slots, 'link-' + item.slot, {
                key: 0,
                link: item.link,
                query: item.query,
                label: item.label
              })
            : (item.link)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  class: "hover:text-zbr-gray-900 hover:underline",
                  to: {
            name: item.link,
            query: item.query ? item.query : null
          }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(item.label)), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (item.slot && item.label)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _renderSlot(_ctx.$slots, 'label-' + item.slot, {
                      label: item.label
                    })
                  ]))
                : (item.slot)
                  ? _renderSlot(_ctx.$slots, item.slot, { key: 3 })
                  : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t(item.label)), 1))
        ], 2))
      }), 128))
    ])
  ], 2))
}
}

})